function encode(value: IClientState): string {
	return JSON.stringify(value);
}

function decode(value: string): IClientState {
	if (!value || value.toString() === '{}') {
		return { ob: false };
	}
	return JSON.parse(value);
}

export default { encode, decode };
